{
  "version": 1,
  "asset_id": "8e068834-17c5-4d78-be5c-695e8a25fc47",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/8e068834-17c5-4d78-be5c-695e8a25fc47/silivri-hizli-elektrikci-7-24-dukkan-10.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/8e068834-17c5-4d78-be5c-695e8a25fc47/silivri-hizli-elektrikci-7-24-dukkan-10.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-10.jpg",
  "size": 181609,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:27:08Z"
}
